import { trackEvent, eventNameConstants, interactionTypeConstants } from 'dibs-tracking';

export const locations = {
    DESIGN_SERIES: 'DESIGN_SERIES',
};

export const authLabels = {
    [locations.DESIGN_SERIES]: 'save search - design series',
};

export function trackFollowSearch({
    label,
    isAdded,
    type = 'search',
}: {
    label: string;
    isAdded: boolean;
    type?: 'seller' | 'search';
}): void {
    const interaction_type = interactionTypeConstants.INTERACTION_TYPE_SEARCH_FAVORITING;
    const step_interaction_name = `${type === 'seller' ? 'seller' : 'search'} ${isAdded ? 'added' : 'removed'}`;

    trackEvent({
        category: interaction_type,
        eventName: eventNameConstants.EVENT_WISHLIST,
        action: step_interaction_name,
        interaction_type,
        label,
        step_interaction_name,
    });
}
